import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const ChannelSessionMarker = ({ channelLabel }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 0.5,
        py: 0.75,
        width: "100%",
      }}
    >
      <SwapHorizIcon sx={{ fontSize: 14, color: theme.palette.text.disabled }} />
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.disabled,
          fontSize: "0.72rem",
          fontStyle: "italic",
        }}
      >
        Continuou via {channelLabel}
      </Typography>
    </Box>
  );
};

export default ChannelSessionMarker;
